import { render, staticRenderFns } from "./TVChannel.vue?vue&type=template&id=e588f7b4&"
import script from "./TVChannel.vue?vue&type=script&lang=js&"
export * from "./TVChannel.vue?vue&type=script&lang=js&"
import style0 from "./TVChannel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports